/* eslint-disable */

import { Typography, Box, Stack } from "@mui/material";
import { MobXProviderContext } from "mobx-react";
import icon from '../../assets/images/icons/fast-delivery.png'
import React from "react";

function NaoHaPedidos(props) {
    const { mapaStore } = React.useContext(MobXProviderContext);

    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            marginTop="100px"
        >
            <Box
                component="img"
                sx={{
                    maxHeight: 130,
                    maxWidth: 130,
                    opacity: 0.3
                }}
                alt="Não há pedidos - ícone de entregador criado por Irvan Kurnianto"
                src={icon}
            />
            <Typography style={{ opacity: 0.5 }} variant="h6" gutterBottom>
                {`${mapaStore.tabIndex === 0 ? 'Não há pedidos pendentes no momento.' : ''}`}
                {`${mapaStore.tabIndex === 1 ? 'Não há pedidos em rota de entrega no momento.' : ''}`}
                {`${mapaStore.tabIndex === 2 ? 'Não há pedidos entregues no momento.' : ''}`}
                {`${mapaStore.tabIndex === 3 ? 'Não há pedidos cancelados no momento.' : ''}`}
            </Typography>
        </Stack>
    )
}

export default NaoHaPedidos;
